<!-- Languages -->
<div>
    <ul class="text-sm text-tertiary font-semibold flex items-center justify-center content-end gap-4 languages">
        <li><a href="javascript:;" (click)="setLanguage('es')">ES</a></li>
        <li><a href="javascript:;" (click)="setLanguage('en')">EN</a></li>
        <li><a href="javascript:;" (click)="setLanguage('eu')">EU</a></li>
        <li><a href="javascript:;" (click)="setLanguage('fr')">FR</a></li>
        <li><a href="javascript:;" (click)="setLanguage('pt')">PT</a></li>
    </ul>
</div>
<!-- END Languages -->
